module.exports = __webpack_public_path__ + "doc___3NxbW.svg";